export const handelOpenModalMyCarrotWallet = () => ({
    type: 'OPEN_MODAL_MY_CARROT_WALLET'
});
export const handelCloseModalMyCarrotWallet = () => ({
    type: 'CLOSE_MODAL_MY_CARROT_WALLET'
});
export const actionChangeDataCarrotWallet = (transactions,total,total_rows,offset) => ({
    type: 'CHANGE_DATA_CARROT_WALLET',transactions,total,total_rows,offset
});
export const actionChangeLoaderMyCarrotWallet = (loader) => ({
    type: 'CHANGE_LOADER_MODAL_CARROT_WALLET',loader
});